<template>
  <div class="nav">
    <div id="profile-pic-container">
      <router-link :to="'/'" exact>
        <img id="profile-pic" src="../assets/profile.jpg">
      </router-link>
    </div>
    <ul>
      <li v-for="link in pages.first"><router-link :to="link.to" exact>{{ link.name }}</router-link></li>
      <br>
      <li v-for="link in pages.second"><router-link :to="link.to" exact>{{ link.name }}</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  data () {
    return {
      title: '',
      pages: {
        first: [
          {
            name: 'Home',
            to: '/'
          },
          {
            name: 'About',
            to: '/about'
          },
          {
            name: 'Current projects',
            to: '/current'
          },
          {
            name: 'Resume',
            to: '/resume'
          },
          {
            name: 'Contact',
            to: '/contact'
          }
        ],
        second: [
          {
            name: 'Last ten films',
            to: '/last-ten-films'
          }
        ]
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#profile-pic-container {
  float: right;
  width: 30%;
  padding: 0px;
}

#profile-pic {
  width: 100%;
  height: 100%; 
}

*.nav ul {
  list-style-type: none;
  padding-left: 0em;
}

*.nav-break {
  margin-top:  10px;
}
*.nav-top
{
  color: #FFF;
  background-color: #ccc;
  text-decoration:none;
  text-transform:uppercase;
  font-style:italic;
}

*.menu-nav ul
{
  text-decoration:none;
}

a.router-link-active {
  font-weight: 600;
}

@media (min-width: 500px) {
  body {
    margin-left: 28%;
  }
  *.nav {
    margin-left: -28%;
    width: 26%;
    position: fixed;
    top: 0;
    overflow: auto;
    height: 100%;
  }
  *.nav ul {
    list-style-type: none;
    padding-left: 1em;
  }
  #profile-pic-container {
    float: none;
    width: 85%;
    padding: 16px;
  }
}

@media (min-width: 784px) {
  body {
    margin-left: 15em;
  }
  *.nav {
    margin-left: -15em;
    width: 14em;
    position: fixed;
    top: 0;
    overflow: auto;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Navigation.vue?6eea0421